import React from "react";
import SF from "../assets/scorefam.jpg";
import GB from "../assets/geeboard.gif";
import RG from "../assets/rentgage.gif";
import SP from "../assets/scope.gif";
import MSF from "../assets/mobileScore.svg";
import MGB from "../assets/mobileGeeBoard.svg";
import MRG from "../assets/mobileRentgage.svg";
import MSP from "../assets/mobileScope.svg";
import AT from "../assets/attendify.svg";
import MAT from "../assets/attendifyMobile.svg";
import WH from "../assets/wormHole.svg";
import MWH from "../assets/mobileWormHole.svg";
import BLD from "../assets/Buylike.png"
import TDT from "../assets/tdt.png"
import CC from "../assets/CityCrib.png"
import WHB from "../assets/WH.png"
import T1 from "../assets/tips.png"
import SWO from "../assets/SWO.png";
import RO from "../assets/RO.png";
import CL from "../assets/CL.png";

import VisibilitySensor from "react-visibility-sensor";
import { Spring } from "react-spring/renderprops";

const Case = () => {
  const DataOfProjects = [
    {
      image: CL,
      mobileImage: CL,
      title: "CarLofty",
      scope: "Auto-Tech",
      description:
        "Carlofty is an app that helps halt the influx of salvaged vehicles from auctions like Copart and IAAI, replacing them with access to over 200 wholesale clean title auctions in the U.S.A.",
      words: ["Frontend Development,NextJS,Marine-Traffic API, ..."],
      year: "2024",
      link: "https://carlofty.com/",
      background: "#FFE6EE",
    },
    {
      image: RO,
      mobileImage: RO,
      title: "Rotacude",
      scope: "Edu-Tech",
      description:
        "Rotacude revolutionizes the hiring process in the education sector by matching dedicated teachers with schools",
      words: ["Frontend Development,ReactJS,..."],
      year: "2024",
      link: "https://rotacude.com/",
      background: "#F0F5FF",
    },
    {
      image: WHB,
      mobileImage: WHB,
      title: "WalletHub",
      scope: "Finance",
      description:
        "WalletHub is one of the biggest personal finance company in the USA that empowers consumers to lead financially healthy lives",
      words: ["Software Testing, SQL, Testrail, Postman ..."],
      year: "2022-2023",
      link: "https://wallethub.com/",
      background: "#F0FAF7",
    },
    {
      image: T1,
      mobileImage: T1,
      title: "Tips180",
      scope: "Sports Prediction",
      description:
        "Tips180 is a football prediction site that provides users with the best free football predictions and tips.",
      words: ["Frontend Development, ReactJS, Tailwind,..."],
      year: "2023",
      link: "https://tips180.com/",
      background: "#F0F6FF",
    },
    // {
    //   image: BLD,
    //   mobileImage: BLD,
    //   title: "BuyLikeDealers",
    //   scope: "Auto-Tech",
    //   description:
    //     "BuyLikeDealers is a  car dealearship company that has made the process of car importation and exportaion seemless by automationg both the logistics and finacial aspect of the entire process.",
    //   words: ["Frontend Development, NextJS, Redux, Tailwind, Stripe,..."],
    //   year: "2021 - 2022",
    //   link: "https://www.buylikedealers.com/",
    //   background: "#FFE6EE",
    // },
    {
      image: SWO,
      mobileImage: SWO,
      title: "SkywardOps",
      scope: "Cloud Services",
      description:
        "SkywardOps is a cutting-edge technology company that offers cloud services, DevOps, and software development solutions.",
      words: ["Frontend Development,ReactJS,TypeScript,Sanity Studio..."],
      year: "2023",
      link: "https://skywardops.com/",
      background: "#666666",
    },
    {
      image: TDT,
      mobileImage: TDT,
      title: "The Direct Tree",
      scope: "Finance",
      description:
        "The Direct Tree is an online market place that creates an environment tailored specifically for your business needs, that assists you in listing your goods, services, and events, as well as managing orders and appointments.",
      words: ["Frontend Development,ReactJS, Redux, Tailwind, Ant Design..."],
      year: "2024*",
      link: "https://tdt-amber.vercel.app/",
      background: "#F0FAF7",
    },
  ];

  return (
    <div className="place-content-center w-full py-16 " id="CaseStudy">
      <h3 className="text-center dark-blue text-4xl lg:text-5xl font-bold fontRB">
        Experience
      </h3>
      <div>
        <div className="block w-full mx-auto ">
          {DataOfProjects.map((project, index) => {
            return (
              <VisibilitySensor partialVisibility>
                {({ isVisible }) => (
                  <Spring
                    delay={100}
                    to={{
                      transform: isVisible
                        ? "translateY(0)"
                        : "translateY(10%)",
                    }}
                  >
                    {(props) => (
                      <a href={project.link} target="_blank" rel="noreferrer">
                        <div
                          key={index}
                          className="w-5/6 h-100 flex flex-wrap lg:flex-nowrap lg:flex-wrapp justify-center place-content-center my-20 mx-auto"
                          style={{ ...props }}
                        >
                          <img
                            alt={project.title}
                            src={project.image}
                            className="lg:w-3/5 rounded-2xl"
                            style={{
                              height: "100%",
                              border:
                                project.title === "CarLofty"
                                  ? "1px solid #D0D5DD"
                                  : "",
                            }}
                          />

                          <div className=" lg:w-2/5 lg:px-10 py-2 fontN grid  content-between ">
                            <div className="flex flex-wrap w-full self-start hidden lg:flex">
                              {project.words.map((word, index) => (
                                <div
                                  key={index}
                                  className="flex  dark-blue text-sm lg:text-md"
                                  style={{ color: "#5D77A2" }}
                                >
                                  {word}
                                </div>
                              ))}
                            </div>

                            <div className="self-end">
                              <h1 className="dark-blue  my-2 text-xl lg:text-4xl fontN font-semibold">
                                {project.title}
                              </h1>
                              <div className="flex flex-wrap self-start my-5 lg:hidden">
                                {project.words.map((word, index) => (
                                  <div
                                    key={index}
                                    className=" dark-blue text-sm lg:text-md"
                                    style={{ color: "#5D77A2" }}
                                  >
                                    {word}
                                  </div>
                                ))}
                              </div>
                              <button
                                className=" hidden lg:block  dark-blue p-2 text-sm rounded-2xl px-5 my-5 text-md font-semibold"
                                style={{
                                  background: project.background,
                                  color: `${
                                    project.title === "Tips180"
                                      ? "#1365E3"
                                      : project.title === "The Direct Tree"
                                      ? "#178083"
                                      : project.title === "SkywardOps"
                                      ? "#15ECE2"
                                      : project.title === "Rotacude"
                                      ? "#191970"
                                      : project.title === "WalletHub"
                                      ? "black"
                                      : "#D80739"
                                  }`,
                                }}
                              >
                                {project.scope}
                              </button>

                              <p
                                className=" dark-blue my-4 text-md"
                                style={{ color: "#4A5F82" }}
                              >
                                {project.description}
                              </p>

                              <p
                                className="text-sm lg:text-lg"
                                style={{ color: "#5D77A2" }}
                              >
                                {project.year}
                              </p>
                            </div>
                          </div>
                        </div>
                      </a>
                    )}
                  </Spring>
                )}
              </VisibilitySensor>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Case;
